var fontFamily = {
  name: "Overpass, sans-serif",
  href: "https://fonts.googleapis.com/css?family=Overpass:200,400,700,800&display=swap"
};
export default fontFamily;